import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

const flatten = appointments => (Array.isArray(appointments) ? appointments : []).flatMap(appointment => [
  appointment, ...flatten(appointment.addonservices), ...flatten(appointment.addanotherservices),
]);
const cancellationDate = (value, timezone) => {
  if (!value) return 'Unavailable';
  const date = moment.utc(value);
  if (!date.isValid()) return 'Unavailable';
  return (timezone && moment.tz.zone(timezone) ? date.tz(timezone) : date).format('DD MMMM YYYY, HH:mm');
};

// Cancellation evidence is recorded separately from invoice payment status.
export default function InvoiceAppointmentHistory({ appointments, timezone }) {
  return <>{flatten(appointments).map((appointment, index) => <li className="py-2" key={appointment.id ?? index}>
    {appointment.service?.name && <h6>Appointment: {appointment.service.name}</h6>}
    <p className="mb-0">Appointment status: {appointment.status || 'Unavailable'}</p>
    {['cancelled', 'canceled'].includes(String(appointment.status).toLowerCase()) && <>
      <p className="mb-0">Cancellation date: {cancellationDate(appointment.cancellation?.date, timezone)}</p>
      <p className="mb-0 text-break">Cancellation reason: {appointment.cancellation?.reason || 'Unavailable'}</p>
    </>}
  </li>)}</>;
}

InvoiceAppointmentHistory.propTypes = { appointments: PropTypes.arrayOf(PropTypes.object), timezone: PropTypes.string };
